import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ShelfStatus } from '@booknest/shared';

import { libraryApi } from '../api/library.api.js';

export interface UpdateShelfEntryVariables {
  entryId: string;
  status?: ShelfStatus;
  rating?: number | null;
}

export function useUpdateShelfEntry() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ entryId, status, rating }: UpdateShelfEntryVariables) => {
      const patch: { status?: ShelfStatus; rating?: number | null } = {};
      if (status !== undefined) patch.status = status;
      if (rating !== undefined) patch.rating = rating;
      return libraryApi.updateEntry(entryId, patch);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['shelf'] });
      void queryClient.invalidateQueries({ queryKey: ['upcoming'] });
    },
  });
}
